module.exports = __webpack_public_path__ + "img/Indochine_Chant_des_Cygnes_15sec.d9f6be4e.jpg";